import Link from "next/link";
import Image from "next/image";
const GeneralFooter = () => {
  const contactDetails = [
    "Phone :8897574909,  8639820425",
    "Monday to Saturday ( 9:00 AM - 9:00 PM IST )",
    "Email : dreamcasarealestates@gmail.com",
  ];

  const CompanyDreamCasaLinks = [
    {
      heading: "COMPANY",
      links: [
        {
          label: "Blogs",
          url: "/blogs",
        },
        {
          label: "Refer us",
          url: "/refer-us",
        },
        {
          label: "About us",
          url: "/about-us",
        },
        {
          label: "Testimonials",
          url: "/testimonials",
        },
        {
          label: "Careers with us",
          url: "/careers",
        },
        {
          label: "Terms & Conditions",
          url: "/terms-and-conditions",
        },
        {
          label: "Privacy Policy",
          url: "/privacy-policy",
        },
      ],
    },
    {
      heading: "DREAM CASA",
      links: [
        {
          label: "Custom Builder",
          url: "/custom-builder",
        },
        {
          label: "Invest in land",
          url: "/invest-in-land",
        },
        {
          label: "Properties",
          url: "/properties",
        },
        {
          label: "List your property",
          url: "/post-property/details",
        },
      ],
    },
  ];

  const socialLinks = {
    heading: "Connect with us",
    links: [
      {
        imageLink: "/icons/social-links/whatsapp.svg",
        url: "https://wa.me/918897574909",
      },
      {
        imageLink: "/icons/social-links/instagram.svg",
        url: "https://www.instagram.com/dreamcasarealestates/",
      },
      {
        imageLink: "/icons/social-links/facebook.svg",
        url: "https://www.facebook.com/Dreamcasarealestates",
      },
      {
        imageLink: "/icons/social-links/youtube.svg",
        url: "",
      },
      {
        imageLink: "/icons/social-links/twitter.svg",
        url: "https://www.linkedin.com/company/dreamcasarealestate/twitter.svg",
      },
    ],
  };

  return (
    <div className="w-full bg-[#081221] md:divide-x p-6 md:p-10 md:divide-slate-500 grid grid-flow-row md:grid-flow-col md:auto-cols-[minmax(min-content,auto)] gap-y-3 md:gap-y-0 divide-y md:divide-y-0">
      <div className="w-full flex justify-start items-start">
        <div className="flex w-fit  flex-col gap-3">
          {
            <span className="text-[#FBFBFB] leading-[22.8px] md:text-base text-[14px] font-Gordita-Bold">
              CONTACT DETAILS :
            </span>
          }
          <div className="flex flex-col gap-2">
            {contactDetails.map((label, index) => {
              return (
                <span
                  className="text-[#FBFBFB] leading-[19.95px] md:text-sm text-[12px] font-Gordita-Medium"
                  key={`index-${index}-link-${label}`}
                >
                  {label}
                </span>
              );
            })}
          </div>
          <div className="flex flex-col gap-2">
            {
              <span className="text-[#FBFBFB] leading-[22.8px] text-sm font-Gordita-Medium">
                {socialLinks.heading}
              </span>
            }
            <div className="flex gap-2">
              {socialLinks.links.map((link, index) => {
                const platformName = link.imageLink
                  .split("/")
                  .pop()
                  ?.split(".")[0]
                  ?.replace(/-/g, " ");

                return (
                  <Link
                    className="text-[#FBFBFB] leading-[19.95px] text-sm font-Gordita-Medium"
                    key={`index-${index}-link-${link.imageLink}`}
                    href={link.url}
                    aria-label={`Visit ${platformName}`}
                  >
                    <Image src={link.imageLink} alt="" width={20} height={20} />
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      {CompanyDreamCasaLinks.map((section, index) => {
        return (
          <div
            key={`index-links-${section.heading}-${index}`}
            className="w-full flex py-5 md:py-0 justify-start md:justify-center items-start"
          >
            <div className="flex w-fit  flex-col gap-3">
              {
                <span className="text-[#FBFBFB] leading-[22.8px]  md:text-base text-[14px] font-Gordita-Bold">
                  {section.heading}
                </span>
              }
              <div className="flex flex-row flex-wrap md:flex-none md:flex-col gap-4 md:gap-2">
                {section.links.map((link, index) => {
                  return (
                    <Link
                      className="whitespace-nowrap md:whitespace-normal hover:text-[#3586FF] text-[#FBFBFB] leading-[19.95px] text-sm font-Gordita-Regular"
                      key={`index-${index}-link-${link.label}`}
                      href={link.url}
                      aria-label={link.label}
                    >
                      {link.label}
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default GeneralFooter;
